<ng-content select="[content]"></ng-content>
<div appDialogActions align="end">
  <app-button variant="ghost-primary" (click)="onCancel.emit(false)">
    {{ cancelText }}
  </app-button>
  <app-button
    variant="ghost-primary"
    [disabled]="confirmDisabled"
    (click)="onConfirm.emit()"
  >
    {{ confirmText }}
  </app-button>
</div>
